import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberintLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 302.36 78.59",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M.18,30.1a28.91,28.91,0,0,1,56.16-9.63H48.49a21.69,21.69,0,1,0,0,19.25h7.85A28.91,28.91,0,0,1,.18,30.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M29.15,59.15A29.05,29.05,0,1,1,56.51,20.42l.08.23H48.38l-.05-.1A21.47,21.47,0,1,0,29.15,51.6a21.66,21.66,0,0,0,19.18-12l.05-.1h8.21l-.08.23A29.19,29.19,0,0,1,29.15,59.15Zm0-57.75A28.7,28.7,0,1,0,56.09,39.9H48.6A21.83,21.83,0,1,1,29.15,8.24,22,22,0,0,1,48.6,20.3h7.49A28.82,28.82,0,0,0,29.15,1.4Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M92.61,20.66h7.85L85,59.16,77.37,78.41H69.52l7.76-19.25L62,20.66h7.76l11.5,28.69Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M77.49,78.59H69.26l7.83-19.43L61.69,20.49h8.14l0,.11L81.21,48.88,92.49,20.49h8.22l-.09.24L85.2,59.23Zm-7.71-.35h7.47L84.87,59.1,100.2,20.84H92.73l-11.52,29-.17-.4L69.59,20.84H62.21L77.47,59.16l0,.07Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M144.57,39.82a19.25,19.25,0,0,1-38.5,0V1.32h7.29V24.87a18.72,18.72,0,0,1,12-4.3A19.28,19.28,0,0,1,144.57,39.82Zm-7.2,0a12,12,0,1,0-12.05,12A12,12,0,0,0,137.37,39.82Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M125.32,59.24a19.45,19.45,0,0,1-19.43-19.42V1.14h7.64V24.5a19,19,0,0,1,11.79-4.11,19.43,19.43,0,0,1,0,38.85ZM106.24,1.49V39.82a19.08,19.08,0,1,0,19.08-19.08A18.57,18.57,0,0,0,113.47,25l-.29.24V1.49Zm19.08,50.56a12.19,12.19,0,1,1,12.23-12.23A12.2,12.2,0,0,1,125.32,52.05Zm0-24A11.84,11.84,0,1,0,137.2,39.82,11.8,11.8,0,0,0,125.32,28Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M150.18,39.82a19.25,19.25,0,1,1,38.5,0,22.51,22.51,0,0,1-.37,3.64H157.94a12,12,0,0,0,11.49,8.41,12.4,12.4,0,0,0,8.6-3.55h8.69a19.26,19.26,0,0,1-36.54-8.5Zm7.76-3.55h23a12.19,12.19,0,0,0-11.5-8.41A12,12,0,0,0,157.94,36.27Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M169.43,59.24a19.43,19.43,0,1,1,19.43-19.42,21.61,21.61,0,0,1-.38,3.67l0,.15H158.18a11.89,11.89,0,0,0,11.25,8.06,12.26,12.26,0,0,0,8.48-3.51l.05,0h9l-.12.25A19.47,19.47,0,0,1,169.43,59.24Zm0-38.5a19.08,19.08,0,1,0,17,27.76H178.1a12.6,12.6,0,0,1-8.67,3.55,12.25,12.25,0,0,1-11.66-8.54l-.07-.22h30.46a21.58,21.58,0,0,0,.35-3.47A19.1,19.1,0,0,0,169.43,20.74Zm11.74,15.7H157.7l.07-.22a12.23,12.23,0,0,1,23.32,0Zm-23-.35h22.5A12.08,12.08,0,0,0,169.43,28,11.89,11.89,0,0,0,158.18,36.09Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M215,20.57v7.19a12,12,0,0,0-12,12.06V59.07h-7.29V39.82A19.29,19.29,0,0,1,215,20.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M203.2,59.24h-7.64V39.82A19.45,19.45,0,0,1,215,20.39h.18v7.55H215A11.85,11.85,0,0,0,203.2,39.82Zm-7.29-.35h6.94V39.82a12.19,12.19,0,0,1,12-12.23V20.74a19.1,19.1,0,0,0-18.9,19.08Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M221.1,20.57h7.29v38.5H221.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M228.57,59.24h-7.64V20.39h7.64Zm-7.29-.35h6.94V20.74h-6.94Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M242.64,59.07h-7.2V39.82a19.25,19.25,0,1,1,38.5,0V59.07h-7.19V39.82a12.06,12.06,0,1,0-24.11,0Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M274.12,59.24h-7.55V39.82a11.88,11.88,0,1,0-23.76,0V59.24h-7.54V39.82a19.43,19.43,0,1,1,38.85,0Zm-7.2-.35h6.85V39.82a19.08,19.08,0,1,0-38.15,0V58.89h6.84V39.82a12.23,12.23,0,0,1,24.46,0Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M212.59.61a12,12,0,0,0,23.91,0Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M282.93,26.62h-7.19V19.43h7.19V.18h7.2V19.43h12.05v7.19H290.13"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M282.76,26.8h-7.2V19.25h7.2V0h7.54V19.25h12.06V26.8H290.3m-.35-.35H302V19.6H290V.35h-6.84V19.6h-7.2v6.85h7.2"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M302.36,59.36a19.22,19.22,0,0,1-19.25-19.25v-15h7.19v15a12.09,12.09,0,0,0,12.06,12.06"
				})
			]
		})
	})
});
export default SvgCyberintLogo;
